export const addressType = {
  BILLING: 'BILLING',
  SHIPPING: 'SHIPPING',
  CONTACT: 'CONTACT',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const STATUS = [
  { value: 'ALL', text: 'ทั้งหมด' },
  { value: 'WAITING', text: 'รอสั่งซื้อ' },
  { value: 'PARTIALLY', text: 'สั่งซื้อแล้วบางส่วน' },
  { value: 'COMPLETED', text: 'สั่งซื้อแล้ว' },
  { value: 'CANCELLED', text: 'ยกเลิก' },
  { value: 'LATED', text: 'เกินกำหนด' },
]

export const STATUS_VALUE = {
  WAITING: 'WAITING',
  PARTIALLY: 'PARTIALLY',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  LATED: 'LATED',
}

export const STATUSTEXTSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return STATUS[0].text
    case STATUS[1].value:
      return STATUS[1].text
    case STATUS[2].value:
      return STATUS[2].text
    case STATUS[3].value:
      return STATUS[3].text
    case STATUS[4].value:
      return STATUS[4].text
    case STATUS[5].value:
      return STATUS[5].text
    default:
      return 'ไม่ระบุ'
  }
}

export const STATUSCOLORSELECTOR = (status) => {
  switch (status) {
    case STATUS[0].value:
      return '#172B4D'
    case STATUS[1].value:
      return '#172B4D'
    case STATUS[2].value:
      return '#00B8D9'
    case STATUS[3].value:
      return '#38B47F'
    case STATUS[4].value:
      return '#FF5B37'
    case STATUS[5].value:
      return '#FF5B37'
    default:
      return '#333'
  }
}

export const TIRE_PATCH_TYPE = [
  { value: 'WORMPILL', text: 'แทงหนอน' },
  { value: 'HOTSTEAM', text: 'สตีมร้อน' },
  { value: 'COLDSTEAM', text: 'สตีมเย็น' },
]
